export default __webpack_public_path__ + "static/media/loki-logo-footer.7594c749.png";